import { useSyncExternalStore } from 'react';
import type { DraftAction, DraftPreviewCardData } from './draft-preview';
import type { DraftWixPreview } from './draft-state';
import { closeBlogReview } from './blog-review-store';
import { dismissDocViewer } from './doc-viewer-presenter';
import { closeEmailReview } from './email-review-store';
import { closeSitePane } from './site-edit-store';

export type DraftReviewSendResult =
  | { status: 'sent' }
  | { status: 'busy' }
  | { status: 'newer'; card: DraftPreviewCardData; sendComments: SendDraftComments };

export type DraftSendSource = 'review' | 'tap';

export type SendDraftComments = (message: string, source?: DraftSendSource, draftAction?: DraftAction) => DraftReviewSendResult;

export interface DraftReviewFlow {
  card: DraftPreviewCardData;
  spaceSlug: string;
  conversationId: string | null;
  sendComments: SendDraftComments;
  beside: boolean;
  wixPreview?: DraftWixPreview | null;
  revision?: string;
}

let flow: DraftReviewFlow | null = null;
const listeners = new Set<() => void>();

function set(next: DraftReviewFlow | null): void {
  flow = next;
  for (const l of [...listeners]) l();
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function openDraftReview(next: DraftReviewFlow): void {
  closeEmailReview();
  closeBlogReview();
  if (next.beside) {
    closeSitePane();
    dismissDocViewer();
  }
  set(next);
}

export function closeDraftReview(): void {
  set(null);
}

export function closeDraftReviewBeside(): void {
  if (flow?.beside) set(null);
}

export function useDraftReviewFlow(): DraftReviewFlow | null {
  return useSyncExternalStore(subscribe, () => flow, () => null);
}
